'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon } from '@/components/ui/icon';
import { AppleIcon, GoogleIcon, NewTwitterIcon } from '@/components/ui/icon/brands';
import { Mail02Icon, Wallet01Icon } from '@/components/ui/icon/glyphs';
import { cn } from '@/lib/ui/utils';
interface ProviderIconProps {
  provider: string;
  className?: string;
}

/**
 * Renders the appropriate icon for an auth provider.
 * Uses Hugeicons for email, wallet, X, Google, and Apple.
 */
export function ProviderIcon(t0) {
  const $ = _c(24);
  const {
    provider,
    className
  } = t0;
  switch (provider) {
    case "email":
    case "otp":
      {
        let t1;
        if ($[0] !== className) {
          t1 = cn("size-5", className);
          $[0] = className;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        let t2;
        if ($[2] !== t1) {
          t2 = <Icon icon={Mail02Icon} className={t1} aria-hidden="true" />;
          $[2] = t1;
          $[3] = t2;
        } else {
          t2 = $[3];
        }
        return t2;
      }
    case "x":
      {
        let t1;
        if ($[4] !== className) {
          t1 = cn("size-5", className);
          $[4] = className;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        let t2;
        if ($[6] !== t1) {
          t2 = <Icon icon={NewTwitterIcon} className={t1} aria-hidden="true" />;
          $[6] = t1;
          $[7] = t2;
        } else {
          t2 = $[7];
        }
        return t2;
      }
    case "wallet":
      {
        let t1;
        if ($[8] !== className) {
          t1 = cn("size-5", className);
          $[8] = className;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        let t2;
        if ($[10] !== t1) {
          t2 = <Icon icon={Wallet01Icon} className={t1} aria-hidden="true" />;
          $[10] = t1;
          $[11] = t2;
        } else {
          t2 = $[11];
        }
        return t2;
      }
    case "google":
      {
        let t1;
        if ($[12] !== className) {
          t1 = cn("size-5", className);
          $[12] = className;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        let t2;
        if ($[14] !== t1) {
          t2 = <Icon icon={GoogleIcon} className={t1} aria-hidden="true" />;
          $[14] = t1;
          $[15] = t2;
        } else {
          t2 = $[15];
        }
        return t2;
      }
    case "apple":
      {
        let t1;
        if ($[16] !== className) {
          t1 = cn("size-5", className);
          $[16] = className;
          $[17] = t1;
        } else {
          t1 = $[17];
        }
        let t2;
        if ($[18] !== t1) {
          t2 = <Icon icon={AppleIcon} className={t1} aria-hidden="true" />;
          $[18] = t1;
          $[19] = t2;
        } else {
          t2 = $[19];
        }
        return t2;
      }
    default:
      {
        let t1;
        if ($[20] !== className) {
          t1 = cn("size-5", className);
          $[20] = className;
          $[21] = t1;
        } else {
          t1 = $[21];
        }
        let t2;
        if ($[22] !== t1) {
          t2 = <Icon icon={Mail02Icon} className={t1} aria-hidden="true" />;
          $[22] = t1;
          $[23] = t2;
        } else {
          t2 = $[23];
        }
        return t2;
      }
  }
}